
import Countup from 'vux/src/components/countup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { commonApi, common } from "@/common/index";
import { mapState, mapActions } from "vuex";
export default {
components: { Countup, XButton },
data() {
return {
doStart: false,
};
},
computed: {
...mapState({
accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
}),
},
methods: {
...mapActions(["getFirstInfo"]),
handleGoSav() {
this.$router.push({ path: "/funds/deposite" });
},
handleGoget() {
this.$router.push({ path: "/funds/withdraw" });
},
handleOne() {
commonApi.PAY.withdrawGames()
.then((data) => {
this.$vux.toast.show({
text: this.$t("mine.Withdrawal.Draw.takeBackSuccess"),
type: "text",
});
this.getFirstInfo();
})
.catch((err) => {
this.$vux.toast.show({ text: err, type: "cancel" });
});
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/components/showYe.vue